var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60579 2.07254C8.68098 1.99299 8.73975 1.8994 8.77876 1.79712C8.81778 1.69485 8.83626 1.58589 8.83317 1.47647C8.83007 1.36706 8.80546 1.25932 8.76072 1.15941C8.71599 1.05951 8.65202 0.969393 8.57246 0.894211C8.4929 0.81903 8.39931 0.760255 8.29704 0.721242C8.19476 0.682229 8.08581 0.663742 7.97639 0.666837C7.86697 0.669933 7.75923 0.694549 7.65933 0.739281C7.55942 0.784014 7.46931 0.847986 7.39413 0.927545L0.310793 8.42754C0.164513 8.58227 0.0830078 8.78712 0.0830078 9.00005C0.0830078 9.21297 0.164513 9.41782 0.310793 9.57255L7.39413 17.0734C7.46881 17.1547 7.55891 17.2203 7.65918 17.2665C7.75945 17.3127 7.8679 17.3385 7.97823 17.3424C8.08856 17.3463 8.19857 17.3283 8.30187 17.2894C8.40516 17.2504 8.49969 17.1913 8.57996 17.1155C8.66023 17.0397 8.72463 16.9487 8.76944 16.8478C8.81424 16.7469 8.83855 16.6381 8.84096 16.5278C8.84336 16.4174 8.82381 16.3076 8.78344 16.2049C8.74307 16.1021 8.68268 16.0084 8.60579 15.9292L2.06246 9.00005L8.60579 2.07254Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.d5303203c81866a344098c1beb767f05.svg";
export { ForwardRef as ReactComponent };